import React from "react"
import { theme } from "../../../theme"
import { operationStrokeColors } from "../helpers"

interface TimeSeriesData {
  timestamp: string
  displayLabel: string
  Delivery: number
  Cancellation: number
  Refund: number
  Release: number
  Compensation: number
}

type Props = {
  active?: boolean
  payload?: Array<{ name: string; value: number; payload: TimeSeriesData; dataKey: string }>
}

const CustomTooltip = ({payload, active} : Props) => {

  if (!active || !payload) return null

  return (
      <div
        style={{
          background: theme.colors.white,
          border: `1px solid ${theme.colors.greyLight}`,
          borderRadius: "0.8rem",
          padding: "1rem",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)"
        }}
      >
        <p style={{ margin: 0, fontSize: "1.2rem", fontWeight: 600, marginBottom: "0.5rem" }}>
          {payload[0].payload.displayLabel}
        </p>
        {payload.map((entry, index) => (
          <p
            key={index}
            style={{
              margin: "0.3rem 0",
              fontSize: "1.2rem",
              color: operationStrokeColors[entry.dataKey] || theme.colors.black
            }}
          >
            {entry.name}: {entry.value}
          </p>
        ))}
      </div>
  )
}

export default CustomTooltip
